import { createSlice } from '@reduxjs/toolkit';
import { addNewPayment, changePaymentStatus, editPayment, getAllPayments, getPaymentById } from './paymentService';

const initialState = {
  allPayments: {
    isPaymentsLoading: null,
    isPaymentsSuccess: null,
    paymentsMessage: null,
    pageCount: 0,
    payments: [],
  },

  newPayment: {
    isPaymentCreating: null,
    isPaymentCreated: null,
    paymentCreationMsg: null,
  },

  editedPayment: {
    isEditingPayment: null,
    isPaymentEdited: null,
    paymentEditedMsg: null
  },

  paymentDetails: {
    isPaymentLoading: null,
    isPaymentSuccess: null,
    payment: null
  },

  changeStatus: {
    isStatusLoading: null,
    isStatusSuccess: null,
  },
};

const paymentsSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllPayments.pending, (state) => {
        state.allPayments = {
          ...initialState.allPayments, // Reset to initial state
          isPaymentsLoading: true,
          paymentsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllPayments.rejected, (state, action) => {
        state.allPayments = {
          ...initialState.allPayments,
          isPaymentsLoading: false,
          isPaymentsSuccess: false,
          paymentsMessage: action.payload || 'Error occurred while fetching payments',
        };
      })

      // FULFILLED
      .addCase(getAllPayments.fulfilled, (state, action) => {
        state.allPayments = {
          ...initialState.allPayments,
          isPaymentsLoading: false,
          isPaymentsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          payments: action.payload.data || [],
        };
      });

    //Payment creating
    builder
      .addCase(addNewPayment.pending, (state) => {
        state.newPayment = {
          ...initialState.newPayment, // Reset to initial state
          isPaymentCreating: true,
          paymentCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewPayment.rejected, (state, action) => {
        state.newPayment = {
          ...initialState.newPayment,
          isPaymentCreating: false,
          isPaymentCreated: false,
          paymentCreationMsg: action.payload || 'Error occurred while creating the payment.',
        };
      })

      // FULFILLED
      .addCase(addNewPayment.fulfilled, (state, action) => {
        state.newPayment = {
          ...initialState.newPayment,
          isPaymentCreating: false,
          isPaymentCreated: true,
          paymentCreationMsg: action.payload || 'Successfully created the payment.',
        };
      });

    //Payment editing
    builder
      .addCase(editPayment.pending, (state) => {
        state.editedPayment = {
          ...initialState.editedPayment, 
          isEditingPayment: true,
          paymentEditedMsg: 'Loading',
        };
      })

      .addCase(editPayment.rejected, (state, action) => {
        state.editedPayment = {
          ...initialState.editedPayment,
          isEditingPayment: false,
          isPaymentEdited: false,
          paymentEditedMsg: action.payload || 'Error occurred while editing the payment.',
        };
      })

      .addCase(editPayment.fulfilled, (state, action) => {
        state.editedPayment = {
          ...initialState.editedPayment,
          isEditingPayment: false,
          isPaymentEdited: true,
          paymentEditedMsg: action.payload || 'Successfully edited the payment.',
        };
      });

       //Payment details
    builder
    .addCase(getPaymentById.pending, (state) => {
      state.paymentDetails = {
        ...initialState.paymentDetails, 
        isPaymentLoading: true,
      };
    })

    .addCase(getPaymentById.rejected, (state, action) => {
      state.paymentDetails = {
        ...initialState.paymentDetails,
        isPaymentLoading: false,
        isPaymentSuccess: false,
      };
    })

    .addCase(getPaymentById.fulfilled, (state, action) => {
      state.paymentDetails = {
        ...initialState.paymentDetails,
        isPaymentLoading: false,
        isPaymentSuccess: true,
        payment: action.payload,
      };
    });

     //Change payment Status
     builder
     .addCase(changePaymentStatus.pending, (state) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: true,
      };
     })

     .addCase(changePaymentStatus.rejected, (state, action) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: false,
        isStatusSuccess: false,
      };
     })

     .addCase(changePaymentStatus.fulfilled, (state, action) => {
       state.changeStatus = {
         ...initialState.changeStatus,
         isStatusLoading: false,
         isStatusSuccess: true,
       };
     });
  },
});

export default paymentsSlice.reducer;
